<template lang="pug">
div(:class="listAnimation")
  template(v-if="sections.length")
    transition-group.preload(
      tag="div"
      name="list"
      :appear="false"
      :duration="0"
    )
      template(v-for="(section, index) in sections")
        .full-width.d-flex.justify-space-between.relative(
          :key="section.component.attrs.id"
          v-bind="getSectionAttrs(section)"
        )
          template(v-if="section.addons.confettiBackground && section.enabled")
            addon-confetti-background
          //- template(v-if="!section.preventEditable && (isEditable || managerCanEdit)")
          //-   v-spacer
          section-component(
            :section="section"
            :sections="sections"
            :event="event"
            :idx="index"
            :is-editable="isEditable"
            :event-manager-access="eventManagerAccess"
            @toggleActive="switchActivitySection(index)"
            @addSection="switchNewSectionModal(index)"
            @removeSection="removeUneditableSection(section)"
            @save="saveSections"
          )
          //- template(v-if="!section.preventEditable && (isEditable || managerCanEdit)")
          //-   section-editing(
          //-     :isEnable="section.enabled"
          //-     :sectionPosition="index"
          //-     :endSectionPosition="sections.length - 1"
          //-     :options="section.editor"
          //-     :sectionId="section.component.type === SECTION_TYPES.GENERIC ? `section-${section.component.attrs.id}` : section.component.attrs.id"
          //-     :alternative-controlls-bg="isSectionForExtendedClass(section)"
          //-     @moveSectionDown="moveSectionDown"
          //-     @moveSectionUp="moveSectionUp"
          //-     @deleteSection="deleteSection"
          //-     @toggleActive="switchActivitySection(index)"
          //-     @addTopSection="switchNewSectionModal(index)"
          //-     @addBottomSection="switchNewSectionModal(index + 1)"
          //-   )

  new-sections-dialog(
    :showDialog="showDialog"
    :newSectionPosition="newSectionPosition"
    @selectSections="addSections"
    @close="() => switchNewSectionModal()"
  )

  //- v-scroll-x-reverse-transition
  //-   template(v-if="!isMainSection")
  //-     .fixed.bottom-0.right-0.ma-16.d-flex.flex-column.align-stretch.gap-16.pointer-events-none
  //-       template(v-if="isEditable || managerCanEdit")
  //-         portal-target(name="event-sections-editing-button")
  //-       template(v-for="(button, index) in manageButtons")
  //-         tooltip-wrap(
  //-           :key="index"
  //-           content-class="redesign redesignControlsBackground redesign-box-shadow rounded-8 opacity-100"
  //-           :value="!!button.tooltip"
  //-           left
  //-         )
  //-           template(#reason)
  //-             p.redesignPrimaryDarken--text {{ button.tooltip }}
  //-           app-button(
  //-             v-bind="button.attrs"
  //-             v-on="button.listeners"
  //-           )
  //-             template(v-if="button.icon")
  //-               v-icon(v-bind="button.icon.attrs") {{ button.icon.is }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { moveElementInArray, deepObjectMerge } from '@/modules/UserEventLanding/functions';
import { BLOCKED_SECTIONS, SECTION_TYPES } from '@/modules/UserEventLanding/constants';
import { SECTIONS_DATA, CARD_TYPES_DATA } from '@/modules/UserEventLanding/glossary';
import { isEqual } from 'lodash';

export default {
  name: 'EventSections',

  components: {
    SectionComponent: () => import('@/modules/Events/components/event-view/SectionComponent.vue'),
    SectionEditing: () => import('@/modules/Events/components/event-view/SectionEditing.vue'),
    NewSectionsDialog: () => import('@/modules/Events/components/event-view/NewSectionsDialog.vue'),

    AddonConfettiBackground: () => import('@/modules/Events/components/event-view/addons/ConfettiBackground.vue'),
  },

  props: {
    event: {
      type: Object,
      default: () => ({}),
    },
    sectionsData: {
      type: Array,
      default: () => [],
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    eventManagerAccess: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      SECTION_TYPES,
      sections: [],
      showDialog: false,
      newSectionPosition: null,
      isSave: false,
      isLoadingPage: true,
    };
  },

  computed: {
    ...mapGetters({
      observerIds: 'redesignHeaderLinks/getObserverIds',
    }),

    managerCanEdit() {
      const { $conf, eventManagerAccess } = this;
      const { PERMISSIONS } = $conf;

      return (
        eventManagerAccess &&
        this.$user.hasPermissionsWithManyOptions([PERMISSIONS.constructor_update], [{ event_id: this.event.id }, {}], { all: false })
      );
    },

    genericSections() {
      return this.sections.filter((section) => section.component.type === SECTION_TYPES.GENERIC) ?? [];
    },

    listAnimation() {
      return this.isLoadingPage ? 'event-sections--preload' : 'event-sections';
    },

    isRouteEditor() {
      return !!this.$route.meta.editor;
    },

    isMainSection() {
      return this.observerIds.includes('main') && this.observerIds.length <= 1;
    },

    manageButtons() {
      const { isEditable, managerCanEdit, isRouteEditor } = this;
      const baseAttrs = {
        height: 40,
        width: 40,
        'min-width': 40,
        class: ['rounded-12', 'pointer-events-all'],
      };
      const scrollOptions = isRouteEditor ? { container: '.custom-application--wrap' } : null;

      return [
        {
          visible: true,
          tooltip: 'Вернуться к началу',
          attrs: deepObjectMerge(baseAttrs, {
            outlined: true,
          }),
          listeners: {
            click: () => this.$vuetify.goTo(0, scrollOptions),
          },
          icon: {
            is: '$iarrow-top-right',
            attrs: {
              class: ['rotate-315'],
              size: 12,
              color: 'redesignPrimaryDarken',
            },
          },
        },
        {
          visible: isEditable || managerCanEdit,
          tooltip: 'Сохранить изменения конструктора',
          attrs: deepObjectMerge(baseAttrs, {
            color: 'redesignPrimary',
          }),
          listeners: {
            click: () => this.saveSections(),
          },
          icon: {
            is: '$isave',
            attrs: {
              size: 24,
            },
          },
        },
        {
          visible: isEditable || managerCanEdit,
          tooltip: 'Сбросить все изменения конструктора',
          attrs: deepObjectMerge(baseAttrs, {
            outlined: true,
          }),
          listeners: {
            click: () => this.restoreSections(),
          },
          icon: {
            is: '$irefresh-outline',
            attrs: {
              size: 24,
              color: 'redesignPrimaryDarken',
            },
          },
        },
      ].filter((button) => button.visible);
    },
  },

  watch: {
    sectionsData: {
      handler(val, prev) {
        if (isEqual(val.map(({ id }) => id).sort(), prev.map(({ id }) => id).sort())) {
        // Сортируем this.sections по порядку id в val
          const idOrder = val.map(({ id }) => id);
          this.sections.sort((a, b) => {
            const aIdx = idOrder.indexOf(a.id);
            const bIdx = idOrder.indexOf(b.id);
            // Если id не найден, оставляем в конце
            return (aIdx === -1 ? Infinity : aIdx) - (bIdx === -1 ? Infinity : bIdx);
          });
          this.sections.forEach((section) => {
            const sectionData = val.find(({ id }) => id === section.id);
            if (sectionData) {
              section.enabled = sectionData?.data?.enabled;
            }
          });
        } else {
          this.sections = this.serializeSections();
        }
      },
      // immediate: true,
    },
    sections: {
      handler() {
        this.setSections(
          this.sections
            .map((section) => {
              if (
                section?.component &&
                !section.attrs.isMock &&
                section.component.attrs.id &&
                section.component.type !== SECTION_TYPES.GENERIC
              ) {
                return {
                  id: section.component.attrs.id,
                  name: section.component.type === SECTION_TYPES.MAIN ? 'Главная' : section.title,
                  baseId: section.id,
                };
              }
              return null;
            })
            .filter(Boolean),
        );
      },
      immediate: true,
    },
  },

  mounted() {
    setTimeout(() => {
      this.isLoadingPage = false;
    }, 100);
  },

  created() {
    this.sections = this.serializeSections();
  },

  beforeDestroy() {
    this.removeSectionsFromStore();
  },

  methods: {
    ...mapActions({
      setSections: 'redesignHeaderLinks/setLinks',
      removeSectionsFromStore: 'redesignHeaderLinks/removeLinks',
    }),
    hasUnsavedChanges() {
      return (
        (this.isEditable || this.managerCanEdit) &&
        JSON.stringify(this.removeUncheckingSectionsOptions(this.sections)) !==
          JSON.stringify(this.removeUncheckingSectionsOptions(this.serializeSections()))
      );
    },
    removeUncheckingSectionsOptions(data) {
      if (!data?.length) {
        return data;
      }

      return data.map((section) => {
        const preparedSection = deepObjectMerge(section, { status: null });

        if (preparedSection.component.type === SECTION_TYPES.GENERIC && preparedSection.component.cardType !== null) {
          preparedSection.component.attrs.cards = (preparedSection.component.attrs.cards || []).map((card) =>
            deepObjectMerge(card, {
              image: null,
              data: {
                image: null,
              },
            }),
          );
        }

        return preparedSection;
      });
    },
    serializeSections() {
      return this.sectionsData
        .map((section, idx) => {
          const implementedSectionTypes = Object.keys(SECTIONS_DATA);
          if (!implementedSectionTypes.includes(section.type.toString())) {
            return null;
          }

          let sectionData = null;

          if (section.type === SECTION_TYPES.GENERIC && section.data?.cardType) {
            sectionData = CARD_TYPES_DATA[section.data.cardType]();

            if (section.id) {
              sectionData.component.attrs.id = `custom-${section.id}`;
            }

            sectionData.component.attrs.cards = (section.cards || []).map((card) => ({
              id: card.id,
              data: JSON.parse(JSON.stringify(card.data)),
              sort_order: card.sort_order ?? idx,
              type: card.type,
              ...(card.image ? { image: card.image } : {}),
            }));

            const dataKeys = Object.keys(section?.data || []).filter((key) => !['enabled'].includes(key));
            dataKeys.forEach((key) => {
              sectionData.component.attrs.data = {
                ...sectionData.component.attrs.data,
                [key]: section.data[key],
              };
            });

            sectionData.component.listeners = this.setCustomSectionListeners(sectionData.component);
          } else {
            sectionData = SECTIONS_DATA[section.type]();
            if (section.type === SECTION_TYPES.MAIN) {
              sectionData.component.listeners = {
                save: () => this.saveSections(),
                restore: () => this.restoreSections(),
              };
            }
          }
          if (this.isEditable && this.event.isAdminTemplate && BLOCKED_SECTIONS.admin_event_template.includes(section.type)) {
            sectionData.component.is = () => import('@/modules/UserEventLanding/components/event-landing/SectionBlocked.vue');
            sectionData.component.listeners = {};
          }
          if (typeof section.data?.enabled === 'boolean') {
            sectionData.enabled = section.data.enabled;
          }
          if (section.id) {
            sectionData.id = section.id;
          }

          return sectionData;
        })
        .filter(Boolean);
    },

    restoreSections() {
      this.$dialogs.confirm({
        attrs: {
          method: () => this.$emit('restoreSections'),
          isRequest: false,
          message: 'Сбросить изменения конструктора к настройкам по умолчанию?',
          closeBtnAttrs: {
            'btn-text': 'Закрыть',
          },
          confirmBtnAttrs: {
            'btn-text': 'Сбросить',
          },
        },
      });
    },

    saveSections() {
      if (!this.hasUnsavedChanges) {
        this.$toast.success('Нет несохранённых изменений в конструкторе', { timeout: 3000 });
        return;
      }

      const serverData = this.sections.map((section, idx) => {
        let base = {};

        if (section.component.type === SECTION_TYPES.GENERIC && section.component.cardType !== null) {
          const cards = section.component.attrs.cards.map((card, cardIdx) => ({
            type: section.component.cardType,
            sort_order: cardIdx,
            data: {
              ...card.data,
            },
            ...(card.data.image ? { image: card.data.image } : {}),
            ...(Number.isInteger(card.id) ? { id: card.id } : {}),
          }));

          base = {
            ...base,
            cards,
            data: {
              ...base.data,
              ...section.component.attrs.data,
              cardType: section.component.cardType,
            },
          };
        }

        base = {
          ...base,
          data: {
            ...base.data,
            enabled: section.enabled,
          },
          type: section.component.type,
          sort_order: idx,
          ...(Number.isInteger(section.id) ? { id: section.id } : {}),
        };

        return base;
      });

      this.$emit('saveSections', serverData);
    },

    switchNewSectionModal(idx = null) {
      this.newSectionPosition = idx;
      this.showDialog = idx !== null;
    },

    moveSectionDown(sectionPosition) {
      moveElementInArray(this.sections, sectionPosition, 1);
    },

    moveSectionUp(sectionPosition) {
      moveElementInArray(this.sections, sectionPosition, -1);
    },

    deleteSection(sectionPosition) {
      // Если это последний элемент кастомных секций
      if (this.genericSections.length === 1) {
        const emptyCustomSection = SECTIONS_DATA[SECTION_TYPES.GENERIC]();
        this.sections.splice(sectionPosition, 1, emptyCustomSection);
      } else {
        this.sections.splice(sectionPosition, 1);
      }
    },

    switchActivitySection(idx) {
      this.sections[idx].enabled = !this.sections[idx].enabled;
      const list = [...this.sectionsData];
      list[idx].data.enabled = this.sections[idx].enabled;
      this.updateSectionsData(list);
    },

    updateSectionsData(sections) {
      this.$emit('update:sectionsData', sections);
    },

    addSections(sections) {
      sections.forEach((section) => {
        const newSection = CARD_TYPES_DATA[section.cardType]();
        newSection.component.listeners = this.setCustomSectionListeners(newSection.component);
        if (this.genericSections.length === 1 && this.genericSections[0].component.cardType === null) {
          this.sections.splice(this.newSectionPosition, 1, newSection);
        } else {
          this.sections.splice(this.newSectionPosition, 0, newSection);
        }
      });

      this.switchNewSectionModal();
    },

    setCustomSectionListeners(component) {
      return {
        changeCards: (list) => {
          component.attrs.cards = list;
        },
        save: this.saveSections,
      };
    },

    removeUneditableSection(section) {
      if (!section || !section.enabled || this.isEditable || this.eventManagerAccess) {
        return;
      }

      section.enabled = false;
      this.sections = this.sections.filter((item) => item.enabled);
    },

    getSectionAttrs(section) {
      const { xs } = this.$vuetify.breakpoint;

      const bgClasses = ['event-sections__section-colorize-background', ...(xs ? ['flex-column'] : [])];
      if (!this.isSectionForExtendedClass(section)) {
        return section.attrs;
      }

      return {
        ...section.attrs,
        class: bgClasses,
      };
    },

    isSectionForExtendedClass(section) {
      return section.component.type !== SECTION_TYPES.MAIN && !section.attrs.isMock;
    },
  },
};
</script>

<style scoped lang="scss">
.event-sections {
  &--preload * {
    transition: none !important;
  }

  &__section-colorize-background {
    &:nth-child(even) {
      background-color: #{$redesignControlsBackground};
      &::v-deep .section-bg-alternative {
        background-color: #{$redesignBackground} !important;
      }
      &::v-deep .section-bg-current {
        background-color: #{$redesignControlsBackground} !important;
      }
      &::v-deep .section-component-border {
        border-color: #{$redesignControlsBackground} !important;
      }
    }
    &:nth-child(odd) {
      background-color: #{$redesignBackground};
      &::v-deep .section-bg-alternative {
        background-color: #{$redesignControlsBackground} !important;
      }
      &::v-deep .section-bg-current {
        background-color: #{$redesignBackground} !important;
      }
      &::v-deep .section-component-border {
        border-color: #{$redesignPrimary} !important;
      }
    }
  }
}
.event-section {
  &__editing-wrapper {
    min-height: 400px;
  }
}

.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}
</style>
